<template>
  <div class="c-form-item-multi-area">
    <el-cascader
      ref="cascader"
      v-model="innerModelValue"
      :options="areaOptions"
      :props="cascaderProps"
      :show-all-levels="showAllLevels"
      :filterable="filterable"
      :collapse-tags="collapseTags"
      clearable
      @change="handleChange"
      style="width: 100%"
    />
  </div>
</template>

<script lang="ts">
export default { inheritAttrs: false }
</script>

<script lang="ts" setup>
import { _, computed, ref } from '@zto/zpage'
import { getAreasRef } from '../../../utils/area'

import type { GenericObject } from '@zto/zpage'

const props = withDefaults(
  defineProps<{
    model: GenericObject
    prop: string
    showAllLevels: boolean
    filterable: boolean
    collapseTags: boolean
    checkStrictly: boolean
    propsConfig: any
  }>(),
  {
    showAllLevels: true,
    filterable: false,
    collapseTags: true,
    checkStrictly: false
  }
)

const innerModelValue = ref<any>([])

const areaOptions = computed(() => getAreasRef().value)

const cascaderProps = computed(() => {
  return {
    multiple: true,
    checkStrictly: props.checkStrictly,
    ...props.propsConfig
  }
})

const cascader = ref<any>()

const handleChange = () => {
  const checkedNodeList = cascader.value.getCheckedNodes().filter((item: any) => !(item.parent && item.parent.checked))
  const newList = checkedNodeList.map((item: any) => item.value)
  props.model[props.prop] = newList
}
</script>

<style scoped>
.example-block {
  margin: 1rem;
}
.example-demonstration {
  margin: 1rem;
}
</style>
